(function(global) {
	'use strict';

	// SLIGHTLY MODIFIED COPY FROM require.js 2.3.2 line 148
	//Allow getting a global that is expressed in
	//dot notation, like 'a.b.c'.
	function getGlobal(value) {
		if (!value) {
			return value;
		}
		var g = global;
		value.split('.').forEach(function (part) {
			g = g[part];
		});
		return g;
	}

	define('global', [], {
		load: function (name, req, onLoad, config) {
			return onLoad(getGlobal(name));
		},
		getGlobal: getGlobal,
	});

})(this);

